import React from 'react';

export const ContactMap = () => {
    return (
        <div className="py-3">
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3710.2167877077386!2d39.1564334!3d21.577459400000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3da59d6217469%3A0x9d1192923fd41a!2sBBR%20CO.LTD!5e0!3m2!1sen!2s!4v1731661694025!5m2!1sen!2s"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                title='Location'
                referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
        </div>
    );
};
